// The survey's Responses page: renders ResponsesPage under the survey layout.

import { createFileRoute } from "@tanstack/react-router";
import { useSurvey } from "@/api/surveys";
import { ResponsesPage } from "@/features/results/responses-page";

export const Route = createFileRoute("/w/$workspaceId/surveys/$surveyId/responses")({
    component: SurveyResponsesRoute,
});

function SurveyResponsesRoute() {
    const { workspaceId, surveyId } = Route.useParams();
    const survey = useSurvey(surveyId).data;
    // The layout above already gated loading/not-found on the same query key.
    if (!survey) return null;
    return <ResponsesPage survey={survey} workspaceId={workspaceId} />;
}
